module.exports = __webpack_public_path__ + "img/002-graphic-design-5.27ec70fc.svg";